import './scss/custom.scss';
import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';

import bannerHandler from './banner-handler';

window._NODEENV = process.env.NODE_ENV;
window._ISEMULATOR = !!process.env.FIRESTORE_EMULATOR_HOST === true;

Alpine.data('banner', bannerHandler);
Alpine.start();
